import { Model } from '@/models/Model';
import JsonApiResponse from '@/models/JsonApiResponse';
import { QueryClient, QueryKey, InfiniteData } from '@tanstack/react-query';
import { ListCacheStrategy } from './BaseListCacheStrategy';

export class InfiniteCacheStrategy<
  T extends Model,
> extends ListCacheStrategy<T> {
  private page: number;

  constructor(queryClient: QueryClient, queryKey: QueryKey) {
    super(queryClient, queryKey);
    this.page = 0;
  }

  setPage(page: number) {
    this.page = page;
    return this;
  }

  set(data: T[]): void {
    const listParents = this.getRawData<InfiniteData<JsonApiResponse<T>>>();
    if (!listParents) return;

    listParents.pages[this.page] = {
      ...listParents.pages[this.page],
      results: data,
    };

    this.queryClient.setQueryData(this.queryKey, listParents);
  }

  getPage(): JsonApiResponse<T> | undefined {
    const listParents = this.queryClient.getQueryData<
      InfiniteData<JsonApiResponse<T>>
    >(this.queryKey);

    return listParents?.pages.at(this.page);
  }

  get(): T[] | undefined {
    const results = this.getPage()?.results;
    return results;
  }

  getAll = () => {
    const listParents = this.queryClient.getQueryData<
      InfiniteData<JsonApiResponse<T>>
    >(this.queryKey);

    return listParents?.pages.flatMap(page => page.results);
  };

  getById = (id: number) => this.getAll()?.find(item => item.id === id);
}
